module.exports = __webpack_public_path__ + "img/microsoft.bbed7a52.svg";